import React from 'react'
import { Doughnut } from 'react-chartjs-2'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ExclamationMarkCircle from '../../../svgs/ExclamationMarkCircle'

const TranslationProgressWidget = ({ stats }) => {
  const { t } = useTranslation('ProjectsPage')
  const totalStrings = () => (
    stats.translated + stats.conflicts + stats.untranslated
  )

  const calcTranslatedPercentage = () => (
    Math.ceil((stats.translated / (totalStrings() / 100)))
  )

  if (!stats) {
    return (
      <div className="d-flex flex-column align-items-center">
        <ExclamationMarkCircle opacity="0.4" size={6} />
        <span className="text-center text-danger">
          {t('ProjectCard.TranslationProgressWidget.errors.invalidStrings')}
        </span>
      </div>
    )
  }

  return (
    <div
      className="position-relative"
      name="translation-progress-widget"
      style={{ width: '140px', height: '140px' }}
    >
        <Doughnut
          data={{
            datasets: [{
              backgroundColor: [
                '#18bc9c',
                '#f39c12',
                '#eeeeee'
              ],
              borderWidth: [0, 0, 0],
              data: [
                stats.translated,
                stats.conflicts,
                stats.untranslated
              ]
            }],
            labels: [
              t('ProjectCard.TranslationProgressWidget.labels.translated'),
              t('ProjectCard.TranslationProgressWidget.labels.conflicts'),
              t('ProjectCard.TranslationProgressWidget.labels.untranslated')
            ]
          }}
          height="140px"
          options={{
            cutout: '85%',
            plugins: {
              legend: {
                display: false
              }
            }
          }}
          width="140px"
        />
        <article
          className="position-absolute h2 text-center text-muted w-100"
          name="progression-percentage"
          style={{
            top: '50%',
            transform: 'translateY(-50%)'
          }}
        >
          {totalStrings() === 0 ? (
            <span>{t('ProjectCard.TranslationProgressWidget.empty')}</span>
          ) : (
            <span>
              {calcTranslatedPercentage()}
              %
            </span>
          )}
        </article>
      <article
        className="position-absolute text-center font-italic w-100"
        name="total-strings"
        style={{ top: '100%', marginTop: '0.5rem' }}
      >
        {t('ProjectCard.TranslationProgressWidget.strings', { count: totalStrings() })}
      </article>
    </div>
  )
}

TranslationProgressWidget.propTypes = {
  stats: PropTypes.shape({
    conflicts: PropTypes.number.isRequired,
    translated: PropTypes.number.isRequired,
    untranslated: PropTypes.number.isRequired
  }).isRequired
}

export default TranslationProgressWidget
